var map = {
	"./logo_pn_invert_de.svg": 91144,
	"./logo_pn_invert_en.svg": 72748,
	"./logo_pn_invert_fr.svg": 25581,
	"./logo_pn_invert_nl.svg": 131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42685;